"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Solutions() {
  const header = useRevealOnScroll({
    threshold: 0.15
  });
  return <section data-section-id="1791" id="boilerfeedpumpsolutions" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-5xl mx-auto">
        <div ref={header.ref} className={`transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-sans text-sm font-bold uppercase tracking-[0.2em] mb-10 md:mb-14 text-primary">
            OUR SOLUTIONS
          </p>
          <h2 className="font-default font-extrabold leading-[1.05] tracking-tight text-foreground text-[44px] sm:text-[56px] md:text-[64px] mb-12">
            Our Boiler Feed <span className="text-primary">Pump Solutions</span>
          </h2>
          
          <div className="pl-6 md:pl-10 border-l-4 border-accent">
            <p className="font-sans text-xl md:text-2xl font-light text-foreground/90 leading-relaxed max-w-4xl">
              AA Eagle Plumbing handles boiler feed pump maintenance, repair, and service for commercial properties across the Miami metro area. We inspect seals, bearings, and motor performance, clear sediment buildup, and get your boiler system back to running the way it should.
            </p>
          </div>
        </div>
      </div>
    </section>;
}